import styled from 'styled-components';
import { deviceWidth } from '../../designs/devices';

export const Mis= styled.div`
position: static;
width:100%;
margin-top: 120px;
overflow-y: scroll; 
display: flex;
flex-direction: column;
justify-content: center;
align-items:center;
z-index: 0;
`;

export const MisToolBar = styled.div`
position:fixed;
width:100%
top:64px;
height: 56px;
display:flex;
flex-direction:row;
align-items:flex-end;
justify-content:center;
background:#ffff;
z-index:100;
box-shadow: 0px 15px 32px -15px rgba(69, 74, 222, 0.12);
`;

export const MisHeaders = styled.span`
position:static;
height:36px;
width:45%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:space-between;;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 18px;
color:${props=>props.color};
line-height: 140%;
`;

export const MisHeaderLine = styled.div`
    position:static;
    width:100%;
    height: 2px;
    background:${props=>props.color};
    border-radius: 2px;
`;

export const DateRangeDiv = styled.div`
position:static;
width:100%;
height:56px;
display:flex;
flex-direction:row;
align-items:center;
justify-content:space-between;
box-sizing: border-box;
padding:5%;
@media ${deviceWidth.mobileXS} { 
    padding:1%;
}
@media ${deviceWidth.mobileS} { 
    padding:3%;
}
`;

export const DateRange = styled.div`
position:static;
width:73%;
height: 34px;
background: #FFFFFF;
color:#6D6D6D;
font-family:Nunito,sans-serif;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 14px;
border: 1px solid #E8E8F1;
display:flex;
flex-direction:row;
align-items:center;
justify-content:flex-start;
box-sizing: border-box;
border-radius: 4px;
@media ${deviceWidth.mobileXS} { 
    width:85%;
}
@media ${deviceWidth.mobileS} { 
    width:73%;
}
`;

export const RangeText = styled.span`
color: #303645;
font-family: Nunito,sans-serif;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 14px;
margin-right:1px;
`;

export const  DateRangeText = styled.span`
position:static;
font-family: Nunito,sans-serif;
height:13px;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 110%;
text-align: center;
color: #454ADE;
`;
export const MisBarChart = styled.div`
box-sizing: border-box;
width:100%;
margin-top:30px;
height:143px;
overflow-x:scroll;
`;
